import { Bound } from "@/models/GenerateCondit";
import { Aggregator, CALCWEIGHT } from "@/models/GenerateCondit/Interrelated";

export default (params) => {
  let originSite = null, destinaSite = null
  if (params['originCenter']) {
    originSite = { key: 'originCenter', value: params['originCenter'] }
  } else if (params['originProvinceArea']) {
    originSite = { key: 'originProvinceArea', value: params['originProvinceArea'] }
  }

  if (params['destinationCenter']) {
    destinaSite = { key: 'destinationCenter', value: params['destinationCenter'] }
  } else if (params['destinationProvinceArea']) {
    destinaSite = { key: 'destinationProvinceArea', value: params['destinationProvinceArea'] }
  }

  const pubFilter = {
    simpleGranularity: 'all',
    dataSource: 'actual_load_unload_result',
    dimensions: ['originCenter', 'destinationCenter'],
    startDate: params.startDate,
    endDate: params.endDate,
    aggregators: [CALCWEIGHT],
    // limit: 10,
    andFilters: [
      { key: 'scanType', value: '录单' },

      // { key: 'originCenter', value: params.scanSite },
      // { key: 'originProvinceArea', value: params.scanSite },
    ]
  }

  if (originSite) {
    pubFilter.andFilters.push(originSite)
  }
  if (destinaSite) {
    pubFilter.andFilters.push(destinaSite)
  }

  return [
    {
      ...pubFilter,
      dimensions: [...pubFilter.dimensions, 'originProvinceArea', 'destinationProvinceArea']
    },
    {
      ...pubFilter,
      andFilters: [
        ...pubFilter.andFilters,
        { key: 'productType', value: '定时达' },
      ]
    },
    {
      ...pubFilter,
      andFilters: [
        ...pubFilter.andFilters,
        { key: 'productType', value: '安心达' },
      ]
    },
    {
      ...pubFilter,
      andFilters: [
        ...pubFilter.andFilters,
        { key: 'productType', value: 'MINI电商小件' },
      ]
    },
    {
      ...pubFilter,
      andFilters: [
        ...pubFilter.andFilters,
        { key: 'productType', value: 'MINI电商大件' },
      ]
    },
    // {
    //   ...pubFilter,
    //   andFilters: [
    //     ...pubFilter.andFilters,
    //     { key: 'productType', value: '普惠达' },
    //   ]
    // },
    {
      ...pubFilter,
      andFilters: [
        ...pubFilter.andFilters,
        { key: 'productType', value: '精准零担' },
      ]
    },
    // {
    //   ...pubFilter,
    //   andFilters: [
    //     ...pubFilter.andFilters,
    //     { key: 'lengthOfTime', value: '次日达' },
    //   ]
    // },
    // {
    //   ...pubFilter,
    //   andFilters: [
    //     ...pubFilter.andFilters,
    //     { key: 'lengthOfTime', value: '隔日达' },
    //   ]
    // },
    // {
    //   remake: '800kg+',
    //   ...pubFilter,
    //   dimensions: [...pubFilter.dimensions, 'waybillNo'],
    //   // 改
    //   aggregators: [new Aggregator('doubleSum', 'calcWeight', 'totalCalcWeight')],
    //   boundFilters: [new Bound('totalCalcWeight', '800')]
    // },
    {
      remake: '其他',
      ...pubFilter,
      dimensions: [...pubFilter.dimensions],
      notFilters: [
        { key: 'lengthOfTime', value: '隔日达' },
        { key: 'lengthOfTime', value: '次日达' },
      ]
    },
    {
      remake: '网络',
      ...pubFilter,
      andFilters: [
        ...pubFilter.andFilters,
        { key: 'goodsType', value: '网络' },
      ]
    },
    // {
    //   remake: '填仓',
    //   ...pubFilter,
    //   // dimensions: ['originSite'],
    //   likeFilters: [
    //     { key: 'originSite', value: '^*T' },
    //   ]
    // },
    // {
    //   ...pubFilter,
    //   andFilters: [
    //     ...pubFilter.andFilters,
    //     { key: 'productType', value: '整车' },
    //   ]
    // },
  ]
}
